module.exports = __webpack_public_path__ + "img/illustration-healthcare-professionals.c2475a3c.svg";